import { render, staticRenderFns } from "./faceLogin.vue?vue&type=template&id=2af5ec38&scoped=true"
import script from "./faceLogin.vue?vue&type=script&lang=js"
export * from "./faceLogin.vue?vue&type=script&lang=js"
import style0 from "./faceLogin.vue?vue&type=style&index=0&id=2af5ec38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5ec38",
  null
  
)

export default component.exports